/* Adagio PDP controller.
   Purchase logic (sizes/prices/variants/cart properties) is ported verbatim
   from the proven customizer section — the cart contract must never change.
   New here: light-UI renderers, PDPViewer glue (presets/zoom/rooms), and the
   ported "on your wall" camera visualiser. */
(function () {
    'use strict';
    var pdpRoot = document.querySelector('[data-pdp]');
    if (!pdpRoot) return;

    var CUSTOMIZER_DATA = window.CUSTOMIZER_DATA || {};
    var PDP_ROOMS = window.PDP_ROOMS || [];
    var baseKeyByIdx = ['aluminum', 'framed', 'acrylic', 'canvas'];
    var typeNameByIdx = ['Aluminium Print', 'Framed Print', 'Acrylic Print', 'Canvas Print'];
    var finishToIdx = { aluminium: 0, framed: 1, acrylic: 2, canvas: 3 };

    // ── Option helpers (ported) ──────────────────────────────────────────
    function normalizeOption(value) {
        return String(value || '')
            .toLowerCase()
            .replace(/×/g, 'x')
            .replace(/["″”]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    }

    var A_SERIES_INCHES = {
        a4: { w: 11.7, h: 8.3 },
        a3: { w: 16.5, h: 11.7 },
        a2: { w: 23.4, h: 16.5 },
        a1: { w: 33.1, h: 23.4 }
    };

    function circleDiameter(label) {
        var m = normalizeOption(label).match(/^(\d+(?:\.\d+)?)\s*(?:in(?:ch(?:es)?)?)?\s*circle\b/);
        return m ? parseFloat(m[1]) : null;
    }

    function sizeDimsFromLabel(label, orientKey) {
        var norm = normalizeOption(label);
        var d = circleDiameter(label);
        if (d) return { w: d, h: d };
        var a = A_SERIES_INCHES[norm];
        if (a) {
            if (orientKey === 'square') return { w: a.h, h: a.h };
            return { w: a.w, h: a.h };
        }
        var m = norm.match(/^(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/);
        if (m) return { w: parseFloat(m[1]), h: parseFloat(m[2]) };
        return orientKey === 'square' ? { w: 20, h: 20 } : { w: 30, h: 20 };
    }

    function parsePriceFormatted(priceFormatted) {
        var n = parseFloat(String(priceFormatted || '').replace(/[^0-9.]/g, ''));
        return isNaN(n) ? Infinity : n;
    }

    // Ported buildSizesFromBase, extended with circle support: circle-labelled
    // sizes are shape-tagged and offered in EVERY orientation (a round print
    // suits any artwork; the crop is centre-square).
    function buildSizesFromBase(baseKey) {
        var bases = CUSTOMIZER_DATA.bases || {};
        var base = bases[baseKey];
        if (!base || !base.variants || !base.variants.length) return null;

        var entries = { landscape: [], portrait: [], square: [] };
        var seen = { landscape: {}, portrait: {}, square: {} };
        var circles = [];
        var circleSeen = {};
        base.variants.forEach(function (v) {
            if (!v.option2) return;
            var labelKey = normalizeOption(v.option2);
            var price = v.available ? parsePriceFormatted(v.priceFormatted) : Infinity;
            if (circleDiameter(v.option2)) {
                if (circleSeen[labelKey]) {
                    var c = circleSeen[labelKey];
                    if (v.available) c.hasAvailable = true;
                    if (price < c.minPrice) c.minPrice = price;
                    return;
                }
                var centry = { label: v.option2, hasAvailable: !!v.available, minPrice: price };
                circleSeen[labelKey] = centry;
                circles.push(centry);
                return;
            }
            var orientKey = normalizeOption(v.option1);
            if (!entries[orientKey]) return;
            if (seen[orientKey][labelKey]) {
                var e = seen[orientKey][labelKey];
                if (v.available) e.hasAvailable = true;
                if (price < e.minPrice) e.minPrice = price;
                return;
            }
            var entry = { label: v.option2, hasAvailable: !!v.available, minPrice: price };
            seen[orientKey][labelKey] = entry;
            entries[orientKey].push(entry);
        });

        var circleSizes = circles
            .filter(function (e) { return e.hasAvailable; })
            .map(function (e) {
                var dims = sizeDimsFromLabel(e.label, 'square');
                return { label: e.label, w: dims.w, h: dims.h, minPrice: e.minPrice, shape: 'circle' };
            });

        var result = {};
        var any = false;
        ['landscape', 'portrait', 'square'].forEach(function (orientKey) {
            var cheapest = null;
            var sizes = entries[orientKey]
                .filter(function (e) { return e.hasAvailable; })
                .map(function (e) {
                    var dims = sizeDimsFromLabel(e.label, orientKey);
                    var size = { label: e.label, w: dims.w, h: dims.h, minPrice: e.minPrice, shape: 'rect' };
                    if (!cheapest || size.minPrice < cheapest.minPrice) cheapest = size;
                    return size;
                }).sort(function (a, b) { return a.w * a.h - b.w * b.h; });
            if (cheapest) cheapest.isDefault = true;
            var all = sizes.concat(circleSizes.map(function (s) {
                return { label: s.label, w: s.w, h: s.h, minPrice: s.minPrice, shape: 'circle' };
            }));
            result[orientKey] = all.length ? all : null;
            if (all.length) any = true;
        });
        return any ? result : null;
    }

    var legacyStd = function () {
        return [
            { label: '12×8"', w: 12, h: 8, shape: 'rect', isDefault: true },
            { label: '18×12"', w: 18, h: 12, shape: 'rect' },
            { label: '24×16"', w: 24, h: 16, shape: 'rect' },
            { label: '30×20"', w: 30, h: 20, shape: 'rect' }
        ];
    };
    var legacyA = function () {
        return [
            { label: 'A4', w: 11.7, h: 8.3, shape: 'rect', isDefault: true },
            { label: 'A3', w: 16.5, h: 11.7, shape: 'rect' },
            { label: 'A2', w: 23.4, h: 16.5, shape: 'rect' },
            { label: 'A1', w: 33.1, h: 23.4, shape: 'rect' }
        ];
    };

    function sizesForType(baseKey, legacy) {
        return buildSizesFromBase(baseKey) || legacy;
    }

    var productConfigDefs = [
        { sizes: sizesForType('aluminum', { landscape: legacyStd(), portrait: legacyStd(), square: null }) },
        {
            sizes: sizesForType('framed', { landscape: legacyA(), portrait: legacyA(), square: null }),
            colors: [
                { label: 'Black', value: 'black', dot: '#1c1c1c' },
                { label: 'White', value: 'white', dot: '#ececec' },
                { label: 'Oak', value: 'oak', dot: '#c9a06e' }
            ],
            defaultColor: 'black',
            hasMat: true
        },
        { sizes: sizesForType('acrylic', { landscape: legacyStd(), portrait: legacyStd(), square: null }) },
        { sizes: sizesForType('canvas', { landscape: legacyStd(), portrait: legacyStd(), square: null }) }
    ];

    var artworkOrientation = normalizeOption(CUSTOMIZER_DATA.artwork && CUSTOMIZER_DATA.artwork.orientation) || 'landscape';

    function sizesFor(def) {
        return (def && def.sizes && def.sizes[artworkOrientation]) || null;
    }

    function sizesForShape(def, shape) {
        var all = sizesFor(def);
        if (!all) return null;
        var filtered = all.filter(function (s) { return (s.shape || 'rect') === shape; });
        return filtered.length ? filtered : null;
    }

    function shapesAvailable(def) {
        var all = sizesFor(def) || [];
        var shapes = [];
        all.forEach(function (s) {
            var sh = s.shape || 'rect';
            if (shapes.indexOf(sh) === -1) shapes.push(sh);
        });
        return shapes;
    }

    function cheapestOf(sizes) {
        var best = null;
        (sizes || []).forEach(function (s) {
            if (!best || s.minPrice < best.minPrice) best = s;
        });
        return best;
    }

    function defaultSelection(def) {
        var shapes = shapesAvailable(def);
        var shape = shapes.indexOf('rect') !== -1 ? 'rect' : (shapes[0] || 'rect');
        var sizes = sizesForShape(def, shape);
        var dSz = sizes ? (sizes.filter(function (s) { return s.isDefault; })[0] || cheapestOf(sizes) || sizes[0]) : null;
        return { size: dSz, color: def.defaultColor || null, mat: !!def.hasMat, shape: shape };
    }

    var productSelections = productConfigDefs.map(defaultSelection);

    // Default to the framed print (the design's hero finish); fall back to the
    // first finish that actually has sizes for this artwork's orientation.
    var activeConfigIdx = 1;

    function firstAvailableIdx() {
        for (var i = 0; i < productConfigDefs.length; i++) {
            if (sizesFor(productConfigDefs[i])) return i;
        }
        return 1;
    }

    function resolveVariant(productIdx, sel) {
        var base = CUSTOMIZER_DATA.bases && CUSTOMIZER_DATA.bases[baseKeyByIdx[productIdx]];
        if (!base || !base.variants || !sel || !sel.size) return null;
        var isCircle = (sel.size.shape || sel.shape) === 'circle';
        var orientKey = normalizeOption(artworkOrientation);
        var sizeKey = normalizeOption(sel.size.label);
        var colourKey = sel.color ? normalizeOption(sel.color) : null;
        for (var i = 0; i < base.variants.length; i++) {
            var v = base.variants[i];
            // Circles live under a single orientation row — match on size alone
            if (!isCircle && normalizeOption(v.option1) !== orientKey) continue;
            if (normalizeOption(v.option2) !== sizeKey) continue;
            if (colourKey && v.option3 && normalizeOption(v.option3) !== colourKey) continue;
            return v;
        }
        return null;
    }

    function chooseBaseVariant(id) {
        for (var idx = 0; idx < baseKeyByIdx.length; idx++) {
            var base = CUSTOMIZER_DATA.bases && CUSTOMIZER_DATA.bases[baseKeyByIdx[idx]];
            var variants = base && base.variants || [];
            for (var n = 0; n < variants.length; n++) {
                var v = variants[n];
                if (String(v.id) !== String(id)) continue;
                var circle = !!circleDiameter(v.option2);
                if (!circle && normalizeOption(v.option1) !== artworkOrientation) return false;
                var def = productConfigDefs[idx];
                var size = (sizesFor(def) || []).filter(function (item) {
                    return normalizeOption(item.label) === normalizeOption(v.option2);
                })[0];
                if (!size) {
                    var dims = sizeDimsFromLabel(v.option2, artworkOrientation);
                    size = { label: v.option2, w: dims.w, h: dims.h, shape: circle ? 'circle' : 'rect' };
                }
                activeConfigIdx = idx;
                productSelections[idx] = {
                    size: size,
                    color: def.colors ? normalizeOption(v.option3) : null,
                    mat: !!def.hasMat,
                    shape: size.shape || 'rect'
                };
                return true;
            }
        }
        return false;
    }

    function chooseCheapestConfiguration() {
        var best = null, bestPrice = Infinity;
        baseKeyByIdx.forEach(function (key) {
            var base = CUSTOMIZER_DATA.bases && CUSTOMIZER_DATA.bases[key];
            (base && base.variants || []).forEach(function (v) {
                if (!v.available) return;
                if (!circleDiameter(v.option2) && normalizeOption(v.option1) !== artworkOrientation) return;
                var price = parsePriceFormatted(v.priceFormatted);
                if (price < bestPrice) { best = v; bestPrice = price; }
            });
        });
        if (best) chooseBaseVariant(best.id);
    }

    function restoreConfigurationFromUrl() {
        if (window.CUSTOM_PRINT_MODE) return;
        var params = new URLSearchParams(window.location.search);
        if (params.has('base_variant') && chooseBaseVariant(params.get('base_variant'))) {
            var selection = productSelections[activeConfigIdx];
            if (params.has('border')) selection.mat = params.get('border') === '1';
        }
    }

    function updateConfigurationUrl(variant) {
        if (window.CUSTOM_PRINT_MODE || !variant) return;
        var url = new URL(window.location.href);
        url.searchParams.set('base_variant', String(variant.id));
        if (productConfigDefs[activeConfigIdx].hasMat) {
            url.searchParams.set('border', productSelections[activeConfigIdx].mat ? '1' : '0');
        } else {
            url.searchParams.delete('border');
        }
        if (url.href !== window.location.href) window.history.replaceState(null, '', url.href);
    }

    function selectionSummary(productIdx, sel) {
        var typeShort = productIdx === 0 ? 'Chromalux' : (typeNameByIdx[productIdx] || '').replace(' Print', '');
        if (!sel || !sel.size) return typeShort + ' · Not available for square artwork';
        var parts = [typeShort, sizeLabel(sel.size)];
        if (sel.color) parts.push(sel.color.charAt(0).toUpperCase() + sel.color.slice(1));
        return parts.join(' · ');
    }

    function displayTitleFor(productIdx) {
        if (window.CUSTOM_PRINT_MODE) {
            return 'Custom Photo: ' + (typeNameByIdx[productIdx] || '');
        }
        var title = (CUSTOMIZER_DATA.artwork && CUSTOMIZER_DATA.artwork.title) || document.title;
        var stripped = title.replace(/\s*(Canvas|Acrylic|Aluminium|Aluminum|Framed|Metal)\s+Print\s*$/i, '');
        return stripped + ' ' + (typeNameByIdx[productIdx] || '');
    }

    // ── Cart (ported — property contract is load-bearing) ────────────────
    function addActiveSelectionToCart() {
        var def = productConfigDefs[activeConfigIdx] || {};
        var sel = productSelections[activeConfigIdx] || {};
        var variant = resolveVariant(activeConfigIdx, sel);
        if (!variant || !variant.available) {
            return Promise.reject(new Error('Variant unavailable'));
        }
        // Custom Prints: the cropped photo is generated at the exact print
        // ratio and uploaded as a file line-item property (multipart)
        if (window.CUSTOM_PRINT_MODE) {
            return cpAddToCart(def, sel, variant);
        }
        var imageNumber = (CUSTOMIZER_DATA.artwork && CUSTOMIZER_DATA.artwork.image) || '';
        var properties = {
            'Artwork': (CUSTOMIZER_DATA.artwork && CUSTOMIZER_DATA.artwork.title) || document.title,
            'SKU': imageNumber + '-' + (variant.sku || '') + '-original',
            '_display_title': displayTitleFor(activeConfigIdx),
            '_artwork_image': imageNumber,
            '_artwork_handle': (CUSTOMIZER_DATA.artwork && CUSTOMIZER_DATA.artwork.handle) || ''
        };
        if (def.hasMat) {
            properties['Faux Mat Border'] = sel.mat ? 'Yes' : 'No';
        }
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variant.id), quantity: 1, properties: properties })
        }).then(function (response) {
            if (!response.ok) throw new Error('Cart add failed: ' + response.status);
            return response.json();
        }).then(function (item) {
            refreshCartCount();
            return {
                image: imageNumber
                    ? 'https://images.adagiointeriors.com/shopify/' + imageNumber + '/' + imageNumber + '-0.webp'
                    : ((item && item.image) || ''),
                name: displayTitleFor(activeConfigIdx),
                variant: selectionSummary(activeConfigIdx, sel),
                price: variant.priceFormatted || ''
            };
        });
    }

    function refreshCartCount() {
        fetch('/cart.js')
            .then(function (response) { return response.json(); })
            .then(function (cart) {
                document.querySelectorAll('[data-meh-cart-count]').forEach(function (badge) {
                    badge.textContent = cart.item_count;
                });
                var viewCart = document.getElementById('atb-modal-viewcart');
                if (viewCart) {
                    viewCart.textContent = cart.item_count > 0
                        ? 'View basket (' + cart.item_count + ')'
                        : 'View basket';
                }
            })
            .catch(function () { /* leave the current count */ });
    }
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) refreshCartCount();
    });

    // ── Added-to-basket modal (ported) ───────────────────────────────────
    var atbModal = document.getElementById('atb-modal');

    function atbModalIsOpen() { return !!(atbModal && !atbModal.hidden); }

    function openAtbModal(details) {
        if (!atbModal) return;
        var thumb = document.getElementById('atb-modal-thumb');
        if (details.image) {
            var src = details.image;
            if (/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) {
                src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=360';
            }
            thumb.src = src;
            thumb.style.display = '';
        } else {
            thumb.style.display = 'none';
        }
        document.getElementById('atb-modal-name').textContent = details.name || '';
        document.getElementById('atb-modal-variant').textContent = details.variant || '';
        document.getElementById('atb-modal-price').textContent = details.price || '';
        atbModal.hidden = false;
        requestAnimationFrame(function () {
            requestAnimationFrame(function () { atbModal.classList.add('is-open'); });
        });
        var checkout = document.getElementById('atb-modal-checkout');
        if (checkout) checkout.focus({ preventScroll: true });
    }

    function closeAtbModal() {
        if (!atbModal) return;
        atbModal.classList.remove('is-open');
        setTimeout(function () { atbModal.hidden = true; }, 320);
    }

    if (atbModal) {
        document.getElementById('atb-modal-backdrop').addEventListener('click', closeAtbModal);
        document.getElementById('atb-modal-close').addEventListener('click', closeAtbModal);
        document.getElementById('atb-modal-continue').addEventListener('click', closeAtbModal);
    }

    // ── DOM refs ─────────────────────────────────────────────────────────
    var els = {
        poster: document.getElementById('pdp-poster'),
        media: document.getElementById('pdp-media'),
        stage: document.getElementById('pdp-stage'),
        hint: document.getElementById('pdp-hint'),
        thumbs: Array.prototype.slice.call(document.querySelectorAll('#pdp-thumbs .pdp-thumb')),
        toggle: document.getElementById('pdp-view-toggle'),
        roomChips: document.getElementById('pdp-room-chips'),
        price: document.getElementById('pdp-price'),
        finishBtns: Array.prototype.slice.call(document.querySelectorAll('#pdp-finish-row .pdp-finish')),
        sizeRow: document.getElementById('pdp-size-row'),
        sizeNote: document.getElementById('pdp-size-note'),
        shapeWrap: document.getElementById('pdp-shape-wrap'),
        shapeRow: document.getElementById('pdp-shape-row'),
        colourWrap: document.getElementById('pdp-colour-wrap'),
        colourRow: document.getElementById('pdp-colour-row'),
        matWrap: document.getElementById('pdp-mat-wrap'),
        matInput: document.getElementById('pdp-mat'),
        summaryText: document.getElementById('pdp-summary-text'),
        atc: document.getElementById('pdp-atc'),
        atcPrice: document.getElementById('pdp-atc-price'),
        sticky: document.getElementById('pdp-sticky'),
        stickyPrice: document.getElementById('pdp-sticky-price'),
        stickySel: document.getElementById('pdp-sticky-sel'),
        stickyAtc: document.getElementById('pdp-sticky-atc')
    };
    var mostPopular = normalizeOption(pdpRoot.getAttribute('data-popular') || '');

    // ── Rendering ────────────────────────────────────────────────────────
    function sizeLabel(size) {
        if (!size || (size.shape || 'rect') === 'circle' || /^a[1-4]$/i.test(size.label.trim())) return size ? size.label : '';
        var w = size.w, h = size.h;
        if (artworkOrientation === 'portrait' && w > h) { var swap = w; w = h; h = swap; }
        if (artworkOrientation === 'landscape' && w < h) { var swap = w; w = h; h = swap; }
        return w + '×' + h + '"';
    }

    function cmText(size) {
        if ((size.shape || 'rect') === 'circle') {
            return '⌀ ' + Math.round(size.w * 2.54) + ' cm';
        }
        var w = size.w, h = size.h;
        if (artworkOrientation === 'portrait' && w > h) { var t = w; w = h; h = t; }
        return Math.round(w * 2.54) + ' × ' + Math.round(h * 2.54) + ' cm';
    }

    function renderFinishStates() {
        els.finishBtns.forEach(function (btn) {
            var idx = finishToIdx[btn.getAttribute('data-finish')];
            var available = !!sizesFor(productConfigDefs[idx]);
            btn.classList.toggle('is-active', idx === activeConfigIdx);
            btn.classList.toggle('is-disabled', !available);
            btn.disabled = !available;
            btn.setAttribute('aria-pressed', idx === activeConfigIdx ? 'true' : 'false');
            if (!available) btn.setAttribute('title', 'Not available for square artwork');
            else btn.removeAttribute('title');
        });
    }

    function renderShapes() {
        var def = productConfigDefs[activeConfigIdx] || {};
        var sel = productSelections[activeConfigIdx] || {};
        var shapes = shapesAvailable(def);
        if (shapes.length < 2) {
            els.shapeWrap.hidden = true;
            return;
        }
        els.shapeWrap.hidden = false;
        els.shapeRow.innerHTML = '';
        [['rect', 'Panel'], ['circle', 'Circle']].forEach(function (pair) {
            if (shapes.indexOf(pair[0]) === -1) return;
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'pdp-shape' + (sel.shape === pair[0] ? ' is-active' : '');
            b.textContent = pair[1];
            b.setAttribute('aria-pressed', sel.shape === pair[0] ? 'true' : 'false');
            b.addEventListener('click', function () {
                if (sel.shape === pair[0]) return;
                sel.shape = pair[0];
                var sizes = sizesForShape(def, sel.shape);
                sel.size = sizes ? (cheapestOf(sizes) || sizes[0]) : null;
                renderAll();
                applySelectionTo3D();
            });
            els.shapeRow.appendChild(b);
        });
    }

    function renderSizes() {
        var def = productConfigDefs[activeConfigIdx] || {};
        var sel = productSelections[activeConfigIdx] || {};
        var sizes = sizesForShape(def, sel.shape || 'rect');
        els.sizeRow.innerHTML = '';
        if (!sizes) {
            els.sizeNote.hidden = false;
            els.sizeNote.textContent = 'This finish isn’t available for square artwork. Choose Framed or Canvas.';
            return;
        }
        els.sizeNote.hidden = true;
        sizes.forEach(function (size) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'pdp-size' + (sel.size && sel.size.label === size.label ? ' is-active' : '');
            var label = document.createElement('span');
            label.className = 'pdp-size__label';
            b.setAttribute('aria-pressed', sel.size && sel.size.label === size.label ? 'true' : 'false');
            label.textContent = sizeLabel(size);
            var dims = document.createElement('span');
            dims.className = 'pdp-size__dims';
            dims.textContent = cmText(size);
            b.appendChild(label);
            b.appendChild(dims);
            if (normalizeOption(size.label) === mostPopular) {
                var tag = document.createElement('span');
                tag.className = 'pdp-size__tag';
                tag.textContent = 'Most popular';
                b.appendChild(tag);
            }
            b.addEventListener('click', function () {
                if (sel.size && sel.size.label === size.label) return;
                sel.size = size;
                renderSizes();
                updateBuy();
                applySelectionTo3D();
            });
            els.sizeRow.appendChild(b);
        });
    }

    function renderColours() {
        var def = productConfigDefs[activeConfigIdx] || {};
        var sel = productSelections[activeConfigIdx] || {};
        if (!def.colors || !sel.size) {
            els.colourWrap.hidden = true;
            return;
        }
        els.colourWrap.hidden = false;
        els.colourRow.innerHTML = '';
        def.colors.forEach(function (c) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'pdp-colour' + (sel.color === c.value ? ' is-active' : '');
            var dot = document.createElement('span');
            dot.className = 'pdp-colour__dot';
            b.setAttribute('aria-pressed', sel.color === c.value ? 'true' : 'false');
            dot.style.background = c.dot;
            b.appendChild(dot);
            b.appendChild(document.createTextNode(c.label));
            b.addEventListener('click', function () {
                if (sel.color === c.value) return;
                sel.color = c.value;
                renderColours();
                updateBuy();
                applySelectionTo3D();
            });
            els.colourRow.appendChild(b);
        });
    }

    function renderMat() {
        var def = productConfigDefs[activeConfigIdx] || {};
        var sel = productSelections[activeConfigIdx] || {};
        var show = !!(def.hasMat && sel.size);
        els.matWrap.hidden = !show;
        if (show) els.matInput.checked = !!sel.mat;
    }

    function summaryText() {
        var sel = productSelections[activeConfigIdx] || {};
        var typeShort = activeConfigIdx === 0 ? 'Chromalux' : (typeNameByIdx[activeConfigIdx] || '').replace(' Print', '');
        if (!sel.size) return typeShort + ' · not available for this artwork';
        var parts = [typeShort, sizeLabel(sel.size)];
        if ((sel.size.shape || sel.shape) === 'circle') parts.push('Circle');
        if (sel.color) parts.push(sel.color.charAt(0).toUpperCase() + sel.color.slice(1) + ' frame');
        var def = productConfigDefs[activeConfigIdx] || {};
        if (def.hasMat) parts.push(sel.mat ? window.AdagioGmcText.borderYes : window.AdagioGmcText.borderNo);
        return parts.join(' · ');
    }

    function updateBuy() {
        var sel = productSelections[activeConfigIdx] || {};
        var variant = resolveVariant(activeConfigIdx, sel);
        var price = variant ? variant.priceFormatted : '';
        els.price.textContent = price || '';
        els.summaryText.textContent = summaryText();
        updateConfigurationUrl(variant);
        els.atcPrice.textContent = price || '';
        var canBuy = !!(variant && variant.available);
        els.atc.disabled = !canBuy;
        if (els.stickyAtc) els.stickyAtc.disabled = !canBuy;
        if (els.stickyPrice) els.stickyPrice.textContent = price || '';
        if (els.stickySel) els.stickySel.textContent = summaryText();
        window.dispatchEvent(new CustomEvent('studio:selection', { detail: { index: activeConfigIdx, orientation: artworkOrientation, selection: sel, summary: summaryText(), price: price, available: canBuy } }));
        if (wallVizIsOpen()) {
            vizRenderSizebar();
            vizUpdateFooter();
        }
    }

    function renderAll() {
        renderFinishStates();
        renderShapes();
        renderSizes();
        renderColours();
        renderMat();
        updateBuy();
    }

    // ── Finish switching ─────────────────────────────────────────────────
    els.finishBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var idx = finishToIdx[btn.getAttribute('data-finish')];
            if (idx === activeConfigIdx || btn.classList.contains('is-disabled')) return;
            activeConfigIdx = idx;
            renderAll();
            applySelectionTo3D();
        });
    });

    if (els.matInput) {
        els.matInput.addEventListener('change', function () {
            var sel = productSelections[activeConfigIdx] || {};
            sel.mat = els.matInput.checked;
            updateBuy();
            applySelectionTo3D();
        });
    }

    // ── Orientation from the artwork image (ported) ──────────────────────
    function setArtworkOrientation(orientation) {
        if (orientation === artworkOrientation) return;
        artworkOrientation = orientation;
        productSelections = productConfigDefs.map(defaultSelection);
        if (!window.CUSTOM_PRINT_MODE) { chooseCheapestConfiguration(); restoreConfigurationFromUrl(); }
        if (!sizesFor(productConfigDefs[activeConfigIdx])) activeConfigIdx = firstAvailableIdx();
        renderAll();
        applySelectionTo3D();
    }

    function detectArtworkOrientation() {
        var classify = function (w, h) {
            if (!w || !h) return;
            var ratio = w / h;
            setArtworkOrientation(ratio >= 1.05 ? 'landscape' : (ratio <= 0.95 ? 'portrait' : 'square'));
        };
        var posterEl = els.poster;
        if (posterEl && posterEl.complete && posterEl.naturalWidth) {
            classify(posterEl.naturalWidth, posterEl.naturalHeight);
        } else if (posterEl) {
            posterEl.addEventListener('load', function () {
                classify(posterEl.naturalWidth, posterEl.naturalHeight);
            });
        }
    }

    // ── 3D viewer glue ───────────────────────────────────────────────────
    function withViewer(fn) {
        if (window.pdpViewer) { fn(window.pdpViewer); return; }
        window.addEventListener('pdpviewer:booted', function () { fn(window.pdpViewer); }, { once: true });
        if (window.PDP_BOOT) window.PDP_BOOT.request();
    }

    function textureUrl() {
        // Custom Prints: the placeholder/applied photo lives here (data:/blob:)
        if (window.SHOPIFY_PRODUCT_IMAGE) return window.SHOPIFY_PRODUCT_IMAGE;
        var n = (CUSTOMIZER_DATA.artwork && CUSTOMIZER_DATA.artwork.image) || '0001';
        return 'https://images.adagiointeriors.com/title/' + n + '/original-print.jpg';
    }

    // Print faces keep the exact artwork colours: drive them from the emissive
    // channel, exempt from tone mapping (ported from the live customizer).
    function applyTrueColorPrints() {
        var v = window.pdpViewer;
        if (!v || !v.product) return;
        v.product.traverse(function (o) {
            if (!o.isMesh || !o.material) return;
            (Array.isArray(o.material) ? o.material : [o.material]).forEach(function (m) {
                var img = m.map && m.map.image;
                var isPhoto = img && (typeof HTMLImageElement !== 'undefined' && img instanceof HTMLImageElement);
                if (!isPhoto || (m.userData && m.userData.trueColor)) return;
                m.userData = m.userData || {};
                m.userData.trueColor = true;
                if (m.color) m.color.setRGB(0, 0, 0);
                if (m.emissive) {
                    m.emissive.setRGB(1, 1, 1);
                    m.emissiveMap = m.map;
                    m.emissiveIntensity = 1;
                }
                m.toneMapped = false;
                m.needsUpdate = true;
            });
        });
    }

    var applyToken = 0;
    function applySelectionTo3D() {
        var v = window.pdpViewer;
        if (!v) return;   // pre-boot: __pdpApplyInitial replays the state at boot
        var sel = productSelections[activeConfigIdx] || {};
        if (!sel.size) return;
        var shape = sel.size.shape || sel.shape || 'rect';
        var w = sel.size.w, h = sel.size.h;
        if (shape !== 'circle' && artworkOrientation === 'portrait' && w > h) { var t = w; w = h; h = t; }
        var def = productConfigDefs[activeConfigIdx] || {};
        var token = ++applyToken;
        v.setConfig({
            type: baseKeyByIdx[activeConfigIdx],
            shape: shape,
            orientation: artworkOrientation === 'square' ? 'landscape' : artworkOrientation,
            widthIn: w,
            heightIn: h,
            frameColor: sel.color || 'black',
            matEffect: !!(def.hasMat && sel.mat),
            textureUrl: textureUrl()
        }).then(function () {
            if (token !== applyToken) return;
            applyTrueColorPrints();
            window.pdpConfigured = true;
            window.dispatchEvent(new CustomEvent('studio:3dconfigured'));
        }).catch(function () { /* keeps last good build */ });
    }

    window.__pdpApplyInitial = function () {
        applySelectionTo3D();
    };

    // ── Stage views, rooms, zoom, fullscreen ─────────────────────────────
    var VIEWS = ['front', 'room', 'detail', 'back'];
    var currentView = 'front';
    var activeRoomIdx = 0;

    function renderRoomChips() {
        if (!els.roomChips) return;
        els.roomChips.innerHTML = '';
        PDP_ROOMS.forEach(function (room, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = i === activeRoomIdx ? 'is-active' : '';
            b.textContent = room.label;
            b.addEventListener('click', function () {
                activeRoomIdx = i;
                renderRoomChips();
                if (currentView === 'room') {
                    withViewer(function (v) { v.setWallRoom(PDP_ROOMS[activeRoomIdx]); });
                }
            });
            els.roomChips.appendChild(b);
        });
    }

    function syncViewUI() {
        pdpRoot.setAttribute('data-view', currentView);
        els.thumbs.forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-view') === currentView);
            t.setAttribute('aria-pressed', t.getAttribute('data-view') === currentView ? 'true' : 'false');
        });
        if (els.toggle) {
            Array.prototype.forEach.call(els.toggle.querySelectorAll('button'), function (b) {
                var mode = b.getAttribute('data-mode');
                b.classList.toggle('is-active', (mode === 'room') === (currentView === 'room'));
            });
        }
        if (els.roomChips) els.roomChips.hidden = currentView !== 'room';
    }

    function setView(view) {
        currentView = view;
        syncViewUI();
        withViewer(function (v) {
            if (view === 'room') {
                v.setWallMode(true);
                v.setWallRoom(PDP_ROOMS[activeRoomIdx] || null);
            } else {
                v.setPreset(view);
            }
        });
    }

    els.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { setView(t.getAttribute('data-view')); });
    });
    if (els.toggle) {
        Array.prototype.forEach.call(els.toggle.querySelectorAll('button'), function (b) {
            b.addEventListener('click', function () {
                setView(b.getAttribute('data-mode') === 'room' ? 'room' : 'front');
            });
        });
    }
    var roomBtn = document.getElementById('pdp-room-btn');
    if (roomBtn) roomBtn.addEventListener('click', function () {
        setView('room');
        if (window.innerWidth < 1024) els.stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    var prevBtn = document.getElementById('pdp-prev');
    var nextBtn = document.getElementById('pdp-next');
    function cycleView(dir) {
        var i = (VIEWS.indexOf(currentView) + dir + VIEWS.length) % VIEWS.length;
        setView(VIEWS[i]);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { cycleView(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { cycleView(1); });

    document.getElementById('pdp-zoom-in').addEventListener('click', function () {
        withViewer(function (v) { v.zoomIn(); });
    });
    document.getElementById('pdp-zoom-out').addEventListener('click', function () {
        withViewer(function (v) { v.zoomOut(); });
    });
    document.getElementById('pdp-reset').addEventListener('click', function () {
        currentView = 'front';
        syncViewUI();
        withViewer(function (v) { v.resetView(); });
    });

    var fullscreenDialog = null;
    var fullscreenPlaceholder = null;
    var fullscreenScroll = 0;
    function setFullscreen(on) {
        if (on === els.media.classList.contains('is-fs')) return;
        if (on) {
            if (!fullscreenDialog) {
                fullscreenDialog = document.createElement('dialog');
                fullscreenDialog.id = 'pdp-fullscreen';
                fullscreenDialog.className = 'pdp-fullscreen';
                fullscreenDialog.setAttribute('aria-label', (window.StudioPdpText || {}).fullscreen_label || 'Full-screen product preview');
                pdpRoot.appendChild(fullscreenDialog);
                fullscreenDialog.addEventListener('cancel', function (event) { event.preventDefault(); setFullscreen(false); });
                fullscreenDialog.addEventListener('close', function () { if (!fullscreenDialog.open) setFullscreen(false); });
            }
            fullscreenScroll = window.scrollY;
            fullscreenPlaceholder = document.createComment('product preview position');
            els.media.parentNode.insertBefore(fullscreenPlaceholder, els.media);
            fullscreenDialog.appendChild(els.media);
            els.media.classList.add('is-fs');
            document.body.classList.add('pdp-fs-open');
            document.documentElement.classList.add('pdp-fs-open');
            fullscreenDialog.showModal();
            document.getElementById('pdp-fs-exit').focus({ preventScroll: true });
        } else {
            els.media.classList.remove('is-fs');
            if (fullscreenPlaceholder) { fullscreenPlaceholder.replaceWith(els.media); fullscreenPlaceholder = null; }
            if (fullscreenDialog && fullscreenDialog.open) fullscreenDialog.close();
            document.body.classList.remove('pdp-fs-open');
            document.documentElement.classList.remove('pdp-fs-open');
            window.scrollTo({ top: fullscreenScroll, behavior: 'instant' });
            document.getElementById('pdp-expand').focus({ preventScroll: true });
        }
        document.getElementById('pdp-expand').setAttribute('aria-expanded', String(on));
        window.dispatchEvent(new CustomEvent('studio:fullscreen', { detail: { open: on } }));
    }
    var fsExit = document.getElementById('pdp-fs-exit');
    if (fsExit) fsExit.addEventListener('click', function () { setFullscreen(false); });
    function toggleFullscreen() {
        var on = !els.media.classList.contains('is-fs');
        setFullscreen(on);
        if (on) withViewer(function () { /* boot so the big stage is live */ });
    }
    document.getElementById('pdp-expand').addEventListener('click', toggleFullscreen);
    var fullscreenLink = document.getElementById('pdp-fullscreen-link');
    if (fullscreenLink) fullscreenLink.addEventListener('click', toggleFullscreen);

    if (els.stage) {
        els.stage.addEventListener('pointerdown', function () {
            if (els.hint) els.hint.classList.add('is-hidden');
        }, { once: true });
    }

    // ── Add to basket wiring ─────────────────────────────────────────────
    function bindAtc(btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
            if (btn.disabled) return;
            var original = btn === els.atc ? null : btn.textContent;
            btn.disabled = true;
            if (btn === els.atc) els.atc.querySelector('span').textContent = 'Adding…';
            else btn.textContent = 'Adding…';
            addActiveSelectionToCart().then(function (details) {
                btn.disabled = false;
                if (btn === els.atc) els.atc.querySelector('span').textContent = 'Add to basket';
                else btn.textContent = original;
                openAtbModal(details);
            }).catch(function (err) {
                // cp:* = custom-print flow interruptions (no photo yet / user
                // declined the quality warning) — not failures
                var soft = err && /^cp:/.test(err.message || '');
                btn.disabled = false;
                if (btn === els.atc) els.atc.querySelector('span').textContent = soft ? 'Add to basket' : 'Try again';
                else btn.textContent = soft ? original : 'Try again';
                if (!soft) setTimeout(function () {
                    if (btn === els.atc) els.atc.querySelector('span').textContent = 'Add to basket';
                    else btn.textContent = original;
                }, 2200);
            });
        });
    }
    bindAtc(els.atc);
    bindAtc(els.stickyAtc);
    if (els.sticky) els.sticky.hidden = false;

    // ── Size guide ───────────────────────────────────────────────────────
    var sizeguide = document.getElementById('pdp-sizeguide');

    function priceFromFor(baseKey, label) {
        var base = CUSTOMIZER_DATA.bases && CUSTOMIZER_DATA.bases[baseKey];
        if (!base) return '';
        var best = null, bestN = Infinity;
        base.variants.forEach(function (v) {
            if (normalizeOption(v.option2) !== normalizeOption(label) || !v.available) return;
            if (!circleDiameter(v.option2) && normalizeOption(v.option1) !== artworkOrientation) return;
            var n = parsePriceFormatted(v.priceFormatted);
            if (n < bestN) { bestN = n; best = v.priceFormatted; }
        });
        return best || '';
    }

    function buildSizeGuide() {
        var body = document.getElementById('pdp-sizeguide-body');
        body.innerHTML = '';
        var names = ['Chromalux high gloss metal print', 'Framed print', 'Acrylic print', 'Canvas print'];
        [1, 3, 2, 0].forEach(function (idx) {
            var sizes = sizesFor(productConfigDefs[idx]);
            if (!sizes) return;
            var h = document.createElement('h3');
            h.textContent = names[idx];
            body.appendChild(h);
            var table = document.createElement('table');
            table.innerHTML = '<thead><tr><th>Size</th><th>Centimetres</th><th>Inches</th><th>From</th></tr></thead>';
            var tbody = document.createElement('tbody');
            sizes.forEach(function (s) {
                var tr = document.createElement('tr');
                var isCircle = (s.shape || 'rect') === 'circle';
                var w = s.w, hgt = s.h;
                if (!isCircle && artworkOrientation === 'portrait' && w > hgt) { var t = w; w = hgt; hgt = t; }
                var inches = isCircle ? ('⌀ ' + s.w + '"') : (w + '" × ' + hgt + '"');
                tr.innerHTML = '<td>' + sizeLabel(s) + '</td><td>' + cmText(s) + '</td><td>' + inches + '</td><td>' +
                    (priceFromFor(baseKeyByIdx[idx], s.label) || '') + '</td>';
                tbody.appendChild(tr);
            });
            table.appendChild(tbody);
            body.appendChild(table);
        });
    }

    function openSizeguide() {
        buildSizeGuide();
        sizeguide.hidden = false;
        requestAnimationFrame(function () {
            requestAnimationFrame(function () { sizeguide.classList.add('is-open'); });
        });
    }
    function closeSizeguide() {
        sizeguide.classList.remove('is-open');
        setTimeout(function () { sizeguide.hidden = true; }, 320);
    }
    document.getElementById('pdp-sizeguide-open').addEventListener('click', openSizeguide);
    document.getElementById('pdp-sizeguide-close').addEventListener('click', closeSizeguide);
    document.getElementById('pdp-sizeguide-backdrop').addEventListener('click', closeSizeguide);

    // ── Review count formatting ──────────────────────────────────────────
    var reviewCount = document.querySelector('[data-review-count]');
    if (reviewCount) {
        var n = parseInt(String(reviewCount.textContent).replace(/[^0-9]/g, ''), 10);
        if (n) reviewCount.textContent = n.toLocaleString('en-GB');
    }

    // ── Escape closes whatever is on top ─────────────────────────────────
    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (cpEls && !cpEls.dpiModal.hidden) { cpDpiAnswer(false); return; }
        if (cpEls && cpEditorIsOpen()) { cpCloseEditor(); return; }
        if (wallVizIsOpen()) { closeWallViz(); return; }
        if (sizeguide && !sizeguide.hidden) { closeSizeguide(); return; }
        if (atbModalIsOpen()) { closeAtbModal(); return; }
        if (els.media.classList.contains('is-fs')) setFullscreen(false);
    });

    // ═════════════════════════════════════════════════════════════════════
    // "Visualise on your wall" — ported from the live customizer, with the
    // 3D snapshot now provided by PDPViewer.captureSnapshot().
    // ═════════════════════════════════════════════════════════════════════
    var vizRoot = document.getElementById('wall-viz');
    var vizEls = vizRoot ? {
        intro: document.getElementById('wall-viz-intro'),
        stageWrap: document.getElementById('wall-viz-stage-wrap'),
        stage: document.getElementById('wall-viz-stage'),
        product: document.getElementById('wall-viz-product'),
        productImg: document.getElementById('wall-viz-product-img'),
        hint: document.getElementById('wall-viz-hint'),
        sizebar: document.getElementById('wall-viz-sizebar'),
        selLabel: document.getElementById('wall-viz-sel'),
        price: document.getElementById('wall-viz-price'),
        share: document.getElementById('wall-viz-share'),
        atc: document.getElementById('wall-viz-atc'),
        retake: document.getElementById('wall-viz-retake'),
        close: document.getElementById('wall-viz-close'),
        take: document.getElementById('wall-viz-take'),
        gallery: document.getElementById('wall-viz-gallery'),
        error: document.getElementById('wall-viz-error'),
        inputCam: document.getElementById('wall-viz-input-camera'),
        inputGal: document.getElementById('wall-viz-input-gallery')
    } : null;

    var viz = {
        photo: null,
        disp: { x: 0, y: 0, w: 0, h: 0 },
        cx: 0.5, cy: 0.45,
        ppi: 0,
        snap: null,
        printInches: null,
        urls: [],
        captureToken: 0
    };

    function wallVizIsOpen() {
        return !!(vizRoot && !vizRoot.hidden);
    }

    function vizClamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
    }

    function selectedInches() {
        var sel = productSelections[activeConfigIdx] || {};
        if (!sel.size) return null;
        var w = sel.size.w, h = sel.size.h;
        if ((sel.size.shape || 'rect') !== 'circle' && artworkOrientation === 'portrait' && w > h) {
            var t = w; w = h; h = t;
        }
        return { w: w, h: h };
    }

    // Straight-on capture from the live PDPViewer (temporarily leaves wall
    // mode — the dialog covers the stage so nothing visibly jumps).
    function capture3DSnapshot() {
        var v = window.pdpViewer;
        if (!v || !v.captureSnapshot || !window.pdpConfigured) return null;
        var wasWall = !!v.wallMode;
        var snap = null;
        try {
            if (wasWall) v.setWallMode(false);
            snap = v.captureSnapshot();
        } catch (e) {
            snap = null;
        } finally {
            if (wasWall) v.setWallMode(true);
        }
        if (snap) snap.mode = '3d';
        return snap;
    }

    function capture2DSnapshot() {
        return new Promise(function (resolve, reject) {
            var inches = selectedInches();
            if (!inches) { reject(new Error('no size')); return; }
            var img = new Image();
            img.onload = function () {
                try {
                    resolve(vizDraw2DComposite(img, activeConfigIdx, inches));
                } catch (e) {
                    reject(e);
                }
            };
            img.onerror = function () { reject(new Error('artwork load failed')); };
            if (window.CUSTOM_PRINT_MODE && window.SHOPIFY_PRODUCT_IMAGE) {
                // data:/blob: preview is same-origin — no crossOrigin, and a
                // query-string suffix would corrupt the URL
                img.src = window.SHOPIFY_PRODUCT_IMAGE;
            } else {
                img.crossOrigin = 'anonymous';
                img.src = textureUrl() + '?viz=1';
            }
        });
    }

    function vizDraw2DComposite(img, idx, inches) {
        var sel = productSelections[activeConfigIdx] || {};
        var frameIn = 0, matIn = 0, frameColor = null;
        if (idx === 1) {
            frameIn = 0.8;
            matIn = sel.mat ? 1.6 : 0;
            frameColor = sel.color || 'black';
        }
        var outerW = inches.w + frameIn * 2;
        var outerH = inches.h + frameIn * 2;
        var pxPerIn = 1400 / Math.max(outerW, outerH);
        var c = document.createElement('canvas');
        c.width = Math.round(outerW * pxPerIn);
        c.height = Math.round(outerH * pxPerIn);
        var ctx = c.getContext('2d');
        var fPx = frameIn * pxPerIn, mPx = matIn * pxPerIn;

        if (fPx) {
            var frameCols = { black: '#1c1c1c', white: '#ececec', oak: '#c9a06e' };
            ctx.fillStyle = frameCols[frameColor] || frameCols.black;
            ctx.fillRect(0, 0, c.width, c.height);
        }
        if (mPx) {
            ctx.fillStyle = '#f6f4ef';
            ctx.fillRect(fPx, fPx, c.width - fPx * 2, c.height - fPx * 2);
        }
        var inset = fPx + mPx;
        ctx.drawImage(img, inset, inset, c.width - inset * 2, c.height - inset * 2);
        if (mPx) {
            ctx.strokeStyle = 'rgba(0,0,0,0.22)';
            ctx.lineWidth = Math.max(1, pxPerIn * 0.06);
            ctx.strokeRect(inset, inset, c.width - inset * 2, c.height - inset * 2);
        }
        if (fPx) {
            ctx.strokeStyle = 'rgba(0,0,0,0.35)';
            ctx.lineWidth = Math.max(1, pxPerIn * 0.04);
            ctx.strokeRect(fPx, fPx, c.width - fPx * 2, c.height - fPx * 2);
        }
        if (idx === 3) {
            var e = Math.max(2, pxPerIn * 0.12);
            ctx.fillStyle = 'rgba(0,0,0,0.18)';
            ctx.fillRect(0, 0, c.width, e);
            ctx.fillRect(0, c.height - e, c.width, e);
            ctx.fillRect(0, 0, e, c.height);
            ctx.fillRect(c.width - e, 0, e, c.height);
        }
        if (idx === 2) {
            var g = ctx.createLinearGradient(0, 0, c.width, c.height);
            g.addColorStop(0, 'rgba(255,255,255,0.12)');
            g.addColorStop(0.35, 'rgba(255,255,255,0)');
            ctx.fillStyle = g;
            ctx.fillRect(0, 0, c.width, c.height);
        }
        return { source: c, inchesW: outerW, inchesH: outerH, mode: '2d' };
    }

    function vizApplySnapshot(snap, token) {
        if (token !== viz.captureToken) return;
        viz.snap = snap;
        viz.printInches = selectedInches();
        var setSrc = function (url) {
            if (token !== viz.captureToken) return;
            vizEls.productImg.onload = function () {
                vizEls.product.classList.remove('is-loading');
                vizRenderProduct();
            };
            vizEls.productImg.src = url;
        };
        if (snap.source.toBlob) {
            snap.source.toBlob(function (blob) {
                if (blob) {
                    var url = URL.createObjectURL(blob);
                    viz.urls.push(url);
                    setSrc(url);
                } else {
                    setSrc(snap.source.toDataURL('image/png'));
                }
            }, 'image/png');
        } else {
            setSrc(snap.source.toDataURL('image/png'));
        }
        vizRenderProduct();
    }

    function vizRefreshSnapshot() {
        if (!vizEls) return;
        var token = ++viz.captureToken;
        vizEls.product.classList.add('is-loading');
        var snap = capture3DSnapshot();
        if (snap) { vizApplySnapshot(snap, token); return; }
        capture2DSnapshot().then(function (s) {
            vizApplySnapshot(s, token);
        }).catch(function () {
            if (token === viz.captureToken) vizEls.product.classList.remove('is-loading');
        });
    }

    function vizScheduleRecapture() {
        var token = ++viz.captureToken;
        vizEls.product.classList.add('is-loading');
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                if (token !== viz.captureToken || !wallVizIsOpen()) return;
                var snap = capture3DSnapshot();
                if (snap) { vizApplySnapshot(snap, token); return; }
                capture2DSnapshot().then(function (s) {
                    vizApplySnapshot(s, token);
                }).catch(function () {
                    if (token === viz.captureToken) vizEls.product.classList.remove('is-loading');
                });
            });
        });
    }

    window.addEventListener('pdpviewer:ready', function () {
        if (wallVizIsOpen() && viz.snap && viz.snap.mode === '2d') vizScheduleRecapture();
    }, { once: true });

    function vizLayoutStage() {
        if (!viz.photo || !vizEls) return;
        var sw = vizEls.stage.clientWidth, sh = vizEls.stage.clientHeight;
        if (!sw || !sh) return;
        var s = Math.min(sw / viz.photo.width, sh / viz.photo.height);
        var dw = viz.photo.width * s, dh = viz.photo.height * s;
        var oldW = viz.disp.w;
        viz.disp = { x: (sw - dw) / 2, y: (sh - dh) / 2, w: dw, h: dh };
        viz.photo.style.left = viz.disp.x + 'px';
        viz.photo.style.top = viz.disp.y + 'px';
        viz.photo.style.width = dw + 'px';
        viz.photo.style.height = dh + 'px';
        if (oldW && viz.ppi) viz.ppi = viz.ppi * (dw / oldW);
        vizRenderProduct();
    }

    function vizRenderProduct() {
        if (!viz.snap || !viz.disp.w || !vizEls) return;
        if (!viz.ppi) viz.ppi = (viz.disp.w / 3) / viz.snap.inchesW;
        var wPx = viz.snap.inchesW * viz.ppi;
        var hPx = wPx * (viz.snap.inchesH / viz.snap.inchesW);
        vizEls.product.style.width = wPx + 'px';
        vizEls.product.style.left = (viz.disp.x + viz.cx * viz.disp.w - wPx / 2) + 'px';
        vizEls.product.style.top = (viz.disp.y + viz.cy * viz.disp.h - hPx / 2) + 'px';
    }

    function vizPpiClamp(ppi) {
        if (!viz.snap || !viz.disp.w) return ppi;
        var minP = (0.10 * viz.disp.w) / viz.snap.inchesW;
        var maxP = (1.40 * viz.disp.w) / viz.snap.inchesW;
        return vizClamp(ppi, minP, maxP);
    }

    function vizLoadViaImg(file) {
        return new Promise(function (resolve, reject) {
            var url = URL.createObjectURL(file);
            var img = new Image();
            img.onload = function () { URL.revokeObjectURL(url); resolve(img); };
            img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode failed')); };
            img.src = url;
        });
    }

    function vizHandleFile(file) {
        if (!file || !vizEls) return;
        vizEls.error.hidden = true;
        var done = function (bmp) {
            try {
                var maxEdge = Math.max(bmp.width, bmp.height) || 1;
                var s = Math.min(1, 2048 / maxEdge);
                var c = document.createElement('canvas');
                c.width = Math.max(1, Math.round(bmp.width * s));
                c.height = Math.max(1, Math.round(bmp.height * s));
                c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
                if (bmp.close) bmp.close();
                viz.photo = c;
                vizEnterStage();
            } catch (e) {
                vizEls.error.hidden = false;
            }
        };
        var fail = function () { vizEls.error.hidden = false; };
        if (window.createImageBitmap) {
            createImageBitmap(file, { imageOrientation: 'from-image' }).then(done).catch(function () {
                createImageBitmap(file).then(done).catch(function () {
                    vizLoadViaImg(file).then(done, fail);
                });
            });
        } else {
            vizLoadViaImg(file).then(done, fail);
        }
    }

    function vizEnterStage() {
        vizEls.intro.hidden = true;
        vizEls.stageWrap.hidden = false;
        vizEls.retake.hidden = false;
        var existing = vizEls.stage.querySelector('canvas');
        if (existing) existing.remove();
        vizEls.stage.insertBefore(viz.photo, vizEls.product);
        viz.photo.style.position = 'absolute';
        viz.cx = 0.5;
        viz.cy = 0.45;
        viz.ppi = 0;
        viz.disp.w = 0;
        vizLayoutStage();
        vizEls.hint.classList.remove('hidden');
        setTimeout(function () { vizEls.hint.classList.add('hidden'); }, 4000);
    }

    var vizPointers = new Map();
    var vizBase = null;

    function vizRebaseline() {
        var pts = [];
        vizPointers.forEach(function (p, id) { pts.push({ id: id, x: p.x, y: p.y }); });
        vizBase = { pts: pts, cx: viz.cx, cy: viz.cy, ppi: viz.ppi };
    }

    if (vizEls) {
        vizEls.stage.addEventListener('pointerdown', function (e) {
            vizEls.stage.setPointerCapture(e.pointerId);
            vizPointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
            vizRebaseline();
            vizEls.hint.classList.add('hidden');
            e.preventDefault();
        });

        vizEls.stage.addEventListener('pointermove', function (e) {
            if (!vizPointers.has(e.pointerId)) return;
            vizPointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
            if (!vizBase || !viz.disp.w || vizBase.pts.length !== vizPointers.size) {
                vizRebaseline();
                return;
            }
            if (vizPointers.size === 1) {
                var b = vizBase.pts[0];
                var cur = vizPointers.get(b.id);
                if (!cur) { vizRebaseline(); return; }
                viz.cx = vizClamp(vizBase.cx + (cur.x - b.x) / viz.disp.w, 0.02, 0.98);
                viz.cy = vizClamp(vizBase.cy + (cur.y - b.y) / viz.disp.h, 0.02, 0.98);
            } else {
                var b1 = vizBase.pts[0], b2 = vizBase.pts[1];
                var c1 = vizPointers.get(b1.id), c2 = vizPointers.get(b2.id);
                if (!c1 || !c2) { vizRebaseline(); return; }
                var baseDist = Math.hypot(b2.x - b1.x, b2.y - b1.y) || 1;
                var curDist = Math.hypot(c2.x - c1.x, c2.y - c1.y);
                viz.ppi = vizPpiClamp(vizBase.ppi * curDist / baseDist);
                viz.cx = vizClamp(vizBase.cx + ((c1.x + c2.x) / 2 - (b1.x + b2.x) / 2) / viz.disp.w, 0.02, 0.98);
                viz.cy = vizClamp(vizBase.cy + ((c1.y + c2.y) / 2 - (b1.y + b2.y) / 2) / viz.disp.h, 0.02, 0.98);
            }
            vizRenderProduct();
        });

        var vizPointerEnd = function (e) {
            if (vizPointers.delete(e.pointerId)) vizRebaseline();
        };
        vizEls.stage.addEventListener('pointerup', vizPointerEnd);
        vizEls.stage.addEventListener('pointercancel', vizPointerEnd);
        vizRoot.addEventListener('gesturestart', function (e) { e.preventDefault(); });
    }

    function vizRenderSizebar() {
        if (!vizEls) return;
        var def = productConfigDefs[activeConfigIdx] || {};
        var sel = productSelections[activeConfigIdx] || {};
        var sizes = sizesForShape(def, sel.shape || 'rect');
        vizEls.sizebar.innerHTML = '';
        if (!sizes) return;
        sizes.forEach(function (size) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'dyn-size-btn' + (sel.size && sel.size.label === size.label ? ' active' : '');
            btn.textContent = sizeLabel(size);
            btn.addEventListener('click', function () { vizOnSizeTap(size); });
            vizEls.sizebar.appendChild(btn);
        });
    }

    function vizOnSizeTap(size) {
        var sel = productSelections[activeConfigIdx];
        if (!sel || (sel.size && sel.size.label === size.label)) return;
        sel.size = size;
        renderAll();
        applySelectionTo3D();

        var prev = viz.printInches;
        var inches = selectedInches();
        viz.printInches = inches;
        if (viz.snap && prev && inches) {
            viz.snap.inchesW *= inches.w / prev.w;
            viz.snap.inchesH *= inches.h / prev.h;
        }
        vizRenderSizebar();
        vizUpdateFooter();
        vizRenderProduct();
        vizScheduleRecapture();
    }

    function vizUpdateFooter() {
        if (!vizEls) return;
        var sel = productSelections[activeConfigIdx] || {};
        var variant = resolveVariant(activeConfigIdx, sel);
        vizEls.selLabel.textContent = selectionSummary(activeConfigIdx, sel);
        vizEls.price.textContent = variant ? variant.priceFormatted : '';
        vizEls.atc.disabled = !(variant && variant.available);
        vizEls.atc.textContent = (variant && !variant.available) ? 'Unavailable' : 'Add to basket';
    }

    function vizComposeFinal() {
        if (!viz.photo || !viz.snap) return null;
        var c = document.createElement('canvas');
        c.width = viz.photo.width;
        c.height = viz.photo.height;
        var ctx = c.getContext('2d');
        ctx.drawImage(viz.photo, 0, 0);
        var f = viz.photo.width / viz.disp.w;
        var w = viz.snap.inchesW * viz.ppi * f;
        var h = w * (viz.snap.inchesH / viz.snap.inchesW);
        var x = viz.cx * viz.disp.w * f - w / 2;
        var y = viz.cy * viz.disp.h * f - h / 2;
        ctx.save();
        ctx.shadowColor = 'rgba(0,0,0,0.38)';
        ctx.shadowBlur = h * 0.05;
        ctx.shadowOffsetY = h * 0.025;
        ctx.drawImage(viz.snap.source, x, y, w, h);
        ctx.restore();
        ctx.save();
        var fs = Math.max(14, Math.round(c.height * 0.022));
        ctx.font = '600 ' + fs + 'px Outfit, sans-serif';
        ctx.textAlign = 'right';
        ctx.shadowColor = 'rgba(0,0,0,0.6)';
        ctx.shadowBlur = 3;
        ctx.fillStyle = 'rgba(255,255,255,0.6)';
        ctx.fillText('adagiointeriors.com', c.width - 16, c.height - 16);
        ctx.restore();
        return c;
    }

    function vizDownloadBlob(blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'adagio-wall-preview.jpg';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
    }

    function openWallViz() {
        if (!vizRoot || !selectedInches()) return;
        if (window.PDP_BOOT) window.PDP_BOOT.request();
        vizRoot.hidden = false;
        requestAnimationFrame(function () {
            requestAnimationFrame(function () { vizRoot.classList.add('is-open'); });
        });
        if (viz.photo) {
            vizEls.intro.hidden = true;
            vizEls.stageWrap.hidden = false;
            vizEls.retake.hidden = false;
            vizLayoutStage();
        } else {
            vizEls.intro.hidden = false;
            vizEls.stageWrap.hidden = true;
            vizEls.retake.hidden = true;
        }
        vizRenderSizebar();
        vizUpdateFooter();
        vizRefreshSnapshot();
    }

    function closeWallViz() {
        if (!vizRoot) return;
        vizRoot.classList.remove('is-open');
        setTimeout(function () { vizRoot.hidden = true; }, 300);
    }

    if (vizEls) {
        var vizOpenBtn = document.getElementById('pdp-viz-open');
        if (vizOpenBtn) vizOpenBtn.addEventListener('click', openWallViz);

        vizEls.close.addEventListener('click', closeWallViz);
        vizEls.take.addEventListener('click', function () { vizEls.inputCam.click(); });
        vizEls.gallery.addEventListener('click', function () { vizEls.inputGal.click(); });
        [vizEls.inputCam, vizEls.inputGal].forEach(function (input) {
            input.addEventListener('change', function () {
                vizHandleFile(input.files && input.files[0]);
                input.value = '';
            });
        });

        vizEls.retake.addEventListener('click', function () {
            viz.photo = null;
            var pc = vizEls.stage.querySelector('canvas');
            if (pc) pc.remove();
            vizEls.intro.hidden = false;
            vizEls.stageWrap.hidden = true;
            vizEls.retake.hidden = true;
        });

        vizEls.atc.addEventListener('click', function () {
            if (vizEls.atc.disabled) return;
            vizEls.atc.disabled = true;
            vizEls.atc.textContent = 'Adding…';
            addActiveSelectionToCart().then(function (details) {
                vizEls.atc.disabled = false;
                vizEls.atc.textContent = 'Add to basket';
                closeWallViz();
                openAtbModal(details);
            }).catch(function (err) {
                var soft = err && /^cp:/.test(err.message || '');
                vizEls.atc.disabled = false;
                vizEls.atc.textContent = soft ? 'Add to basket' : 'Try again';
                if (soft) closeWallViz();   // the photo editor opened on top
            });
        });

        vizEls.share.addEventListener('click', function () {
            var c = vizComposeFinal();
            if (!c) return;
            c.toBlob(function (blob) {
                if (!blob) return;
                var file = null;
                try {
                    file = new File([blob], 'adagio-wall-preview.jpg', { type: 'image/jpeg' });
                } catch (e) { /* File constructor unsupported */ }
                var shared = false;
                if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
                    try {
                        var p = navigator.share({ files: [file], title: 'My wall preview: Adagio Interiors' });
                        if (p && p.catch) {
                            p.catch(function (err) {
                                if (!err || err.name !== 'AbortError') vizDownloadBlob(blob);
                            });
                            shared = true;
                        }
                    } catch (e) { /* fall through to download */ }
                }
                if (!shared) vizDownloadBlob(blob);
            }, 'image/jpeg', 0.9);
        });

        window.addEventListener('resize', function () {
            if (wallVizIsOpen() && viz.photo) vizLayoutStage();
        });

        window.__wallViz = {
            open: openWallViz,
            state: function () {
                var r = vizEls.product.getBoundingClientRect();
                return {
                    open: wallVizIsOpen(),
                    hasPhoto: !!viz.photo,
                    snapMode: viz.snap ? viz.snap.mode : null,
                    disp: viz.disp, cx: viz.cx, cy: viz.cy, ppi: viz.ppi,
                    inches: viz.snap ? { w: viz.snap.inchesW, h: viz.snap.inchesH } : null,
                    productRect: { x: r.x, y: r.y, w: r.width, h: r.height }
                };
            },
            setTransform: function (cx, cy, ppi) {
                viz.cx = cx;
                viz.cy = cy;
                if (ppi) viz.ppi = vizPpiClamp(ppi);
                vizRenderProduct();
            },
            handleFile: vizHandleFile,
            saveFallback: function () {
                var c = vizComposeFinal();
                if (!c) return Promise.resolve(0);
                return new Promise(function (res) {
                    c.toBlob(function (blob) {
                        if (blob) vizDownloadBlob(blob);
                        res(blob ? blob.size : 0);
                    }, 'image/jpeg', 0.9);
                });
            }
        };
    }

    // ═════════════════════════════════════════════════════════════════════
    // Custom Prints editor — ported from the legacy customizer. Core crop
    // maths unchanged; the apply path now feeds the photo through
    // SHOPIFY_PRODUCT_IMAGE + textureUrl() and rebuilds via applySelectionTo3D.
    // ═════════════════════════════════════════════════════════════════════
    var cpRoot = document.getElementById('custom-print-editor');
    var cpEls = cpRoot ? {
        intro: document.getElementById('cpe-intro'),
        cropWrap: document.getElementById('cpe-crop-wrap'),
        stage: document.getElementById('cpe-stage'),
        canvas: document.getElementById('cpe-canvas'),
        frame: document.getElementById('cpe-frame'),
        hint: document.getElementById('cpe-hint'),
        ratioBtns: Array.prototype.slice.call(document.querySelectorAll('.cpe-ratio')),
        rotate: document.getElementById('cpe-rotate'),
        retake: document.getElementById('cpe-retake'),
        zoom: document.getElementById('cpe-zoom'),
        zoomIn: document.getElementById('cpe-zoom-in'),
        zoomOut: document.getElementById('cpe-zoom-out'),
        qualityDot: document.getElementById('cpe-quality-dot'),
        qualityText: document.getElementById('cpe-quality-text'),
        apply: document.getElementById('cpe-apply'),
        close: document.getElementById('cpe-close'),
        take: document.getElementById('cpe-take'),
        choose: document.getElementById('cpe-choose'),
        error: document.getElementById('cpe-error'),
        inputCam: document.getElementById('cpe-input-camera'),
        inputFile: document.getElementById('cpe-input-file'),
        reopen: document.getElementById('cpe-reopen'),
        reopenLabel: document.getElementById('cpe-reopen-label'),
        stepOpen: document.getElementById('pdp-cpe-open'),
        dpiModal: document.getElementById('cpe-dpi-modal'),
        dpiText: document.getElementById('cpe-dpi-text'),
        dpiBack: document.getElementById('cpe-dpi-back'),
        dpiAnyway: document.getElementById('cpe-dpi-anyway')
    } : null;

    var cp = {
        source: null,          // EXIF-corrected canvas, rotation baked in
        srcW: 0, srcH: 0,
        ratioKey: 'landscape',
        cropRect: null,        // {x,y,w,h} in source px — the single invariant
        view: { s: 1, offX: 0, offY: 0, sMin: 1 },
        frameBox: { x: 0, y: 0, w: 0, h: 0 },
        previewUrl: null,
        applied: false,
        fileName: '',
        screenshotHint: false
    };

    var CP_RATIOS = { landscape: 1.5, portrait: 2 / 3, square: 1 };
    var CP_MAX_INCHES = { landscape: 48, portrait: 48, square: 30 };

    function cpEditorIsOpen() {
        return !!(cpRoot && !cpRoot.hidden);
    }

    function cpSourceCap() {
        return (navigator.maxTouchPoints && navigator.maxTouchPoints > 1) ? 4096 : 5000;
    }

    function cpOpenEditor() {
        if (!cpRoot) return;
        cpRoot.hidden = false;
        requestAnimationFrame(function () {
            requestAnimationFrame(function () { cpRoot.classList.add('is-open'); });
        });
        cpEls.reopen.hidden = true;
        if (cp.source) {
            cpShowCropStep();
        } else {
            cpEls.intro.hidden = false;
            cpEls.cropWrap.hidden = true;
        }
    }

    function cpCloseEditor() {
        if (!cpRoot) return;
        cpRoot.classList.remove('is-open');
        setTimeout(function () { cpRoot.hidden = true; }, 300);
        cpEls.reopen.hidden = false;
        var label = cp.applied ? 'Change photo' : 'Add your photo';
        cpEls.reopenLabel.textContent = label;
        if (cpEls.stepOpen) cpEls.stepOpen.textContent = cp.applied ? 'Change your photo' : 'Add your photo';
    }

    function cpShowCropStep() {
        cpEls.intro.hidden = true;
        cpEls.cropWrap.hidden = false;
        cpLayoutStage();
        if (cp.cropRect) {
            cpRestoreViewFromCrop();
        } else {
            cpResetView();
        }
        cpAfterViewChange();
        cpEls.hint.classList.remove('hidden');
        setTimeout(function () { cpEls.hint.classList.add('hidden'); }, 4000);
    }

    function cpLayoutStage() {
        var sw = cpEls.stage.clientWidth, sh = cpEls.stage.clientHeight;
        if (!sw || !sh) return;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        cpEls.canvas.width = Math.round(sw * dpr);
        cpEls.canvas.height = Math.round(sh * dpr);
        cpEls.canvas.getContext('2d').setTransform(dpr, 0, 0, dpr, 0, 0);
        var A = CP_RATIOS[cp.ratioKey];
        var fw = Math.min(0.86 * sw, 0.78 * sh * A);
        var fh = fw / A;
        cp.frameBox = { x: (sw - fw) / 2, y: (sh - fh) / 2, w: fw, h: fh };
        cpEls.frame.style.left = cp.frameBox.x + 'px';
        cpEls.frame.style.top = cp.frameBox.y + 'px';
        cpEls.frame.style.width = fw + 'px';
        cpEls.frame.style.height = fh + 'px';
        cp.view.sMin = Math.max(fw / cp.srcW, fh / cp.srcH);
    }

    function cpResetView() {
        cp.view.s = cp.view.sMin;
        cp.view.offX = cp.frameBox.x - (cp.srcW * cp.view.s - cp.frameBox.w) / 2;
        cp.view.offY = cp.frameBox.y - (cp.srcH * cp.view.s - cp.frameBox.h) / 2;
        cpClampView();
    }

    function cpRestoreViewFromCrop() {
        var r = cp.cropRect;
        cp.view.s = Math.max(cp.frameBox.w / r.w, cp.view.sMin);
        cp.view.offX = cp.frameBox.x - r.x * cp.view.s;
        cp.view.offY = cp.frameBox.y - r.y * cp.view.s;
        cpClampView();
    }

    function cpClampView() {
        var v = cp.view, f = cp.frameBox;
        v.s = Math.max(v.sMin, Math.min(v.sMin * 8, v.s));
        v.offX = Math.max(f.x + f.w - cp.srcW * v.s, Math.min(f.x, v.offX));
        v.offY = Math.max(f.y + f.h - cp.srcH * v.s, Math.min(f.y, v.offY));
    }

    function cpUpdateCropRect() {
        var v = cp.view, f = cp.frameBox;
        cp.cropRect = {
            x: Math.max(0, (f.x - v.offX) / v.s),
            y: Math.max(0, (f.y - v.offY) / v.s),
            w: Math.min(cp.srcW, f.w / v.s),
            h: Math.min(cp.srcH, f.h / v.s)
        };
    }

    function cpRedraw() {
        var ctx = cpEls.canvas.getContext('2d');
        var sw = cpEls.stage.clientWidth, sh = cpEls.stage.clientHeight;
        ctx.clearRect(0, 0, sw, sh);
        if (!cp.source) return;
        ctx.drawImage(cp.source, cp.view.offX, cp.view.offY, cp.srcW * cp.view.s, cp.srcH * cp.view.s);
    }

    function cpAfterViewChange() {
        cpClampView();
        cpUpdateCropRect();
        cpRedraw();
        cpUpdateQualityMeter();
        if (cpEls && cpEls.zoom && cp.view.sMin) {
            var t = Math.log(cp.view.s / cp.view.sMin) / Math.log(8);
            cpEls.zoom.value = Math.round(Math.max(0, Math.min(1, t)) * 100);
        }
    }

    function cpSetZoomT(t) {
        if (!cp.source) return;
        t = Math.max(0, Math.min(1, t));
        var sNew = cp.view.sMin * Math.pow(8, t);
        var fcx = cp.frameBox.x + cp.frameBox.w / 2;
        var fcy = cp.frameBox.y + cp.frameBox.h / 2;
        cp.view.offX = fcx - ((fcx - cp.view.offX) / cp.view.s) * sNew;
        cp.view.offY = fcy - ((fcy - cp.view.offY) / cp.view.s) * sNew;
        cp.view.s = sNew;
        cpAfterViewChange();
    }

    function cpUpdateQualityMeter() {
        if (!cp.cropRect) return;
        var longPx = Math.max(cp.cropRect.w, cp.cropRect.h);
        var maxSharpIn = Math.min(CP_MAX_INCHES[cp.ratioKey], Math.floor(longPx / 100));
        var dot = cpEls.qualityDot, txt = cpEls.qualityText;
        dot.className = '';
        if (longPx < 150) {
            dot.className = 'red';
            txt.textContent = 'This image is too small to print';
            cpEls.apply.disabled = true;
            return;
        }
        cpEls.apply.disabled = false;
        if (maxSharpIn >= CP_MAX_INCHES[cp.ratioKey]) {
            txt.textContent = 'Excellent quality. Sharp at every size';
        } else if (maxSharpIn >= 24) {
            txt.textContent = 'Great quality. Sharp up to ' + maxSharpIn + '″ prints';
        } else if (maxSharpIn >= 12) {
            dot.className = 'amber';
            txt.textContent = 'Good for smaller prints (up to ' + maxSharpIn + '″). Use the original photo for large sizes';
        } else {
            dot.className = 'red';
            txt.textContent = 'Very low quality. Screenshots and WhatsApp images print blurry';
        }
        if (cp.screenshotHint && maxSharpIn < CP_MAX_INCHES[cp.ratioKey]) {
            txt.textContent += ' (this looks like a screenshot)';
        }
    }

    function cpLoadViaImg(file) {
        return new Promise(function (resolve, reject) {
            var url = URL.createObjectURL(file);
            var img = new Image();
            img.onload = function () { URL.revokeObjectURL(url); resolve(img); };
            img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode failed')); };
            img.src = url;
        });
    }

    function cpHandleFile(file) {
        if (!file || !cpEls) return;
        cpEls.error.hidden = true;
        cp.fileName = file.name || '';
        cp.screenshotHint = /screenshot|screen_shot|whatsapp|wa\d{4}/i.test(cp.fileName);
        var done = function (bmp) {
            try {
                var cap = cpSourceCap();
                var scale = Math.min(1, cap / Math.max(bmp.width, bmp.height));
                var c = document.createElement('canvas');
                c.width = Math.max(1, Math.round(bmp.width * scale));
                c.height = Math.max(1, Math.round(bmp.height * scale));
                c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
                if (bmp.close) bmp.close();
                if (!cp.screenshotHint && window.screen &&
                    ((c.width === screen.width && c.height === screen.height) ||
                     (c.width === screen.height && c.height === screen.width))) {
                    cp.screenshotHint = true;
                }
                cp.source = c;
                cp.srcW = c.width;
                cp.srcH = c.height;
                cp.cropRect = null;
                cpAutoRatio();       // frame matches the photo's orientation…
                cpShowCropStep();    // …and opens fully zoomed out, centred
            } catch (e) {
                cpShowError();
            }
        };
        if (window.createImageBitmap) {
            createImageBitmap(file, { imageOrientation: 'from-image' }).then(done).catch(function () {
                createImageBitmap(file).then(done).catch(function () {
                    cpLoadViaImg(file).then(done, cpShowError);
                });
            });
        } else {
            cpLoadViaImg(file).then(done, cpShowError);
        }
    }

    function cpShowError() {
        cpEls.error.textContent = 'That photo couldn’t be read. Try a JPEG or PNG (tip: export it from your Photos app first).';
        cpEls.error.hidden = false;
        cpEls.intro.hidden = false;
        cpEls.cropWrap.hidden = true;
    }

    // Match the crop family to the photo's own shape (same thresholds the
    // catalogue uses) and sync the ratio chips — called on load and rotate,
    // before the fully-zoomed-out centred reset.
    function cpAutoRatio() {
        if (!cp.srcW || !cp.srcH) return;
        var ar = cp.srcW / cp.srcH;
        cp.ratioKey = ar >= 1.05 ? 'landscape' : (ar <= 0.95 ? 'portrait' : 'square');
        cpEls.ratioBtns.forEach(function (b) {
            b.classList.toggle('active', b.getAttribute('data-ratio') === cp.ratioKey);
        });
    }

    function cpRotate90() {
        if (!cp.source) return;
        var c = document.createElement('canvas');
        c.width = cp.srcH;
        c.height = cp.srcW;
        var ctx = c.getContext('2d');
        ctx.translate(c.width, 0);
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(cp.source, 0, 0);
        cp.source = c;
        cp.srcW = c.width;
        cp.srcH = c.height;
        cp.cropRect = null;
        cpAutoRatio();   // rotated photo → the crop family follows it
        cpLayoutStage();
        cpResetView();
        cpAfterViewChange();
    }

    // ── Apply: preview texture for the 3D viewer ──
    function cpApplyPhoto() {
        if (!cp.source || !cp.cropRect || cpEls.apply.disabled) return;
        var r = cp.cropRect;
        var scale = Math.min(1, 2048 / Math.max(r.w, r.h));
        var c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(r.w * scale));
        c.height = Math.max(1, Math.round(r.h * scale));
        var ctx = c.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(cp.source, r.x, r.y, r.w, r.h, 0, 0, c.width, c.height);
        c.toBlob(function (blob) {
            if (!blob) return;
            if (cp.previewUrl) URL.revokeObjectURL(cp.previewUrl);
            cp.previewUrl = URL.createObjectURL(blob);
            applyCustomTexture(cp.previewUrl, cp.ratioKey);
            cp.applied = true;
            cpCloseEditor();
        }, 'image/jpeg', 0.9);
    }

    function applyCustomTexture(url, orientation) {
        window.SHOPIFY_PRODUCT_IMAGE = url;   // textureUrl() serves this from now on
        var poster = document.getElementById('pdp-poster');
        if (poster) poster.src = url;
        var thumb = document.querySelector('[data-pdp-thumb-art]');
        if (thumb) thumb.src = url;
        if (orientation !== artworkOrientation) {
            setArtworkOrientation(orientation);   // re-renders options + rebuilds the 3D
        } else {
            applySelectionTo3D();                 // same shape — swap the texture
        }
        if (window.PDP_BOOT) window.PDP_BOOT.request();
    }

    // ── DPI confirm dialog ──
    var cpDpiResolve = null;

    function cpDpiConfirm(dpi, sizeLabel) {
        return new Promise(function (resolve) {
            cpDpiResolve = resolve;
            cpEls.dpiText.textContent = 'This photo prints at roughly ' + dpi +
                ' DPI at ' + sizeLabel + '. We recommend 150+ for a crisp result. ' +
                'A smaller size would look sharper.';
            cpEls.dpiModal.hidden = false;
        });
    }

    function cpDpiAnswer(ok) {
        cpEls.dpiModal.hidden = true;
        if (cpDpiResolve) { cpDpiResolve(ok); cpDpiResolve = null; }
    }

    // ── Print file: exact ratio of the selected size, never upscaled ──
    function cpGeneratePrintFile(selInches) {
        return new Promise(function (resolve, reject) {
            var A = selInches.w / selInches.h;
            var r = cp.cropRect;
            var cx = r.x + r.w / 2, cy = r.y + r.h / 2;
            var w = Math.max(r.w, r.h * A);
            var h = w / A;
            if (w > cp.srcW) { w = cp.srcW; h = w / A; }
            if (h > cp.srcH) { h = cp.srcH; w = h * A; }
            var x = Math.max(0, Math.min(cp.srcW - w, cx - w / 2));
            var y = Math.max(0, Math.min(cp.srcH - h, cy - h / 2));
            var outLong = Math.min(6000, Math.round(Math.max(w, h)));
            var outW = w >= h ? outLong : Math.round(outLong * A);
            var outH = w >= h ? Math.round(outLong / A) : outLong;
            var c = document.createElement('canvas');
            c.width = Math.max(1, outW);
            c.height = Math.max(1, outH);
            var ctx = c.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.drawImage(cp.source, x, y, w, h, 0, 0, c.width, c.height);
            var dpi = Math.round(Math.max(c.width, c.height) / Math.max(selInches.w, selInches.h));
            var encode = function (quality, retry) {
                c.toBlob(function (blob) {
                    if (!blob) { reject(new Error('encode failed')); return; }
                    if (blob.size > 19 * 1024 * 1024 && retry) { encode(0.85, false); return; }
                    resolve({ blob: blob, dpi: dpi, outW: c.width, outH: c.height });
                }, 'image/jpeg', quality);
            };
            encode(0.92, true);
        });
    }

    // ── Custom-mode add to cart (multipart with the file property) ──
    function cpAddToCart(def, sel, variant) {
        if (!cp.applied || !cp.source || !cp.cropRect) {
            cpOpenEditor();
            return Promise.reject(new Error('cp:no-photo'));
        }
        var inches = selectedInches();
        if (!inches) return Promise.reject(new Error('Variant unavailable'));
        return cpGeneratePrintFile(inches).then(function (res) {
            if (res.dpi < 100) {
                return cpDpiConfirm(res.dpi, sel.size.label).then(function (ok) {
                    if (!ok) throw new Error('cp:declined');
                    return res;
                });
            }
            return res;
        }).then(function (res) {
            var fd = new FormData();
            fd.append('id', String(variant.id));
            fd.append('quantity', '1');
            fd.append('properties[Artwork]', 'Your photo');
            fd.append('properties[SKU]', 'CUSTOM-' + (variant.sku || '') + '-upload');
            fd.append('properties[_display_title]', displayTitleFor(activeConfigIdx));
            fd.append('properties[_artwork_handle]', 'custom-print');
            if (def.hasMat) fd.append('properties[Faux Mat Border]', sel.mat ? 'Yes' : 'No');
            fd.append('properties[Your image]',
                new File([res.blob], 'custom-print-' + Date.now() + '.jpg', { type: 'image/jpeg' }));
            return fetch('/cart/add.js', { method: 'POST', body: fd });
        }).then(function (response) {
            if (!response.ok) throw new Error('Cart add failed: ' + response.status);
            return response.json();
        }).then(function (item) {
            var fileUrl = item && item.properties && item.properties['Your image'];
            if (!fileUrl || String(fileUrl).indexOf('/uploads/') === -1) {
                throw new Error('Upload missing from cart line');
            }
            refreshCartCount();
            return {
                image: cp.previewUrl || '',
                name: displayTitleFor(activeConfigIdx),
                variant: selectionSummary(activeConfigIdx, sel),
                price: variant.priceFormatted || ''
            };
        });
    }

    // ── Gestures + wiring ──
    if (window.CUSTOM_PRINT_MODE && cpEls) {
        var cpPointers = new Map();
        var cpBase = null;

        var cpRebaseline = function () {
            var pts = [];
            cpPointers.forEach(function (p, id) { pts.push({ id: id, x: p.x, y: p.y }); });
            cpBase = { pts: pts, s: cp.view.s, offX: cp.view.offX, offY: cp.view.offY };
        };

        cpEls.stage.addEventListener('pointerdown', function (e) {
            if (!cp.source) return;
            cpEls.stage.setPointerCapture(e.pointerId);
            cpPointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
            cpRebaseline();
            cpEls.hint.classList.add('hidden');
            e.preventDefault();
        });

        cpEls.stage.addEventListener('pointermove', function (e) {
            if (!cpPointers.has(e.pointerId)) return;
            cpPointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
            if (!cpBase || cpBase.pts.length !== cpPointers.size) { cpRebaseline(); return; }
            if (cpPointers.size === 1) {
                var b = cpBase.pts[0];
                var cur = cpPointers.get(b.id);
                if (!cur) { cpRebaseline(); return; }
                cp.view.offX = cpBase.offX + (cur.x - b.x);
                cp.view.offY = cpBase.offY + (cur.y - b.y);
            } else {
                var b1 = cpBase.pts[0], b2 = cpBase.pts[1];
                var c1 = cpPointers.get(b1.id), c2 = cpPointers.get(b2.id);
                if (!c1 || !c2) { cpRebaseline(); return; }
                var baseDist = Math.hypot(b2.x - b1.x, b2.y - b1.y) || 1;
                var sNew = Math.max(cp.view.sMin, Math.min(cp.view.sMin * 8,
                    cpBase.s * Math.hypot(c2.x - c1.x, c2.y - c1.y) / baseDist));
                var rect = cpEls.stage.getBoundingClientRect();
                var bmx = (b1.x + b2.x) / 2 - rect.left, bmy = (b1.y + b2.y) / 2 - rect.top;
                var cmx = (c1.x + c2.x) / 2 - rect.left, cmy = (c1.y + c2.y) / 2 - rect.top;
                cp.view.offX = cmx - ((bmx - cpBase.offX) / cpBase.s) * sNew;
                cp.view.offY = cmy - ((bmy - cpBase.offY) / cpBase.s) * sNew;
                cp.view.s = sNew;
            }
            cpAfterViewChange();
        });

        var cpPointerEnd = function (e) {
            if (cpPointers.delete(e.pointerId)) cpRebaseline();
        };
        cpEls.stage.addEventListener('pointerup', cpPointerEnd);
        cpEls.stage.addEventListener('pointercancel', cpPointerEnd);

        cpEls.stage.addEventListener('wheel', function (e) {
            if (!cp.source) return;
            e.preventDefault();
            var rect = cpEls.stage.getBoundingClientRect();
            var mx = e.clientX - rect.left, my = e.clientY - rect.top;
            var sNew = Math.max(cp.view.sMin, Math.min(cp.view.sMin * 8,
                cp.view.s * Math.pow(1.0015, -e.deltaY)));
            cp.view.offX = mx - ((mx - cp.view.offX) / cp.view.s) * sNew;
            cp.view.offY = my - ((my - cp.view.offY) / cp.view.s) * sNew;
            cp.view.s = sNew;
            cpAfterViewChange();
        }, { passive: false });

        cpRoot.addEventListener('gesturestart', function (e) { e.preventDefault(); });

        // Ratio chips
        var cpSetRatio = function (key) {
            if (!CP_RATIOS[key]) return;
            cp.ratioKey = key;
            cpEls.ratioBtns.forEach(function (b) {
                b.classList.toggle('active', b.getAttribute('data-ratio') === key);
            });
            if (!cp.source) return;
            var centre = cp.cropRect
                ? { x: cp.cropRect.x + cp.cropRect.w / 2, y: cp.cropRect.y + cp.cropRect.h / 2 }
                : { x: cp.srcW / 2, y: cp.srcH / 2 };
            cpLayoutStage();
            cp.view.s = Math.max(cp.view.s, cp.view.sMin);
            cp.view.offX = cp.frameBox.x + cp.frameBox.w / 2 - centre.x * cp.view.s;
            cp.view.offY = cp.frameBox.y + cp.frameBox.h / 2 - centre.y * cp.view.s;
            cpAfterViewChange();
        };
        cpEls.ratioBtns.forEach(function (b) {
            b.addEventListener('click', function () { cpSetRatio(b.getAttribute('data-ratio')); });
        });
        cpSetRatio('landscape');

        // Uploads
        cpEls.take.addEventListener('click', function () { cpEls.inputCam.click(); });
        cpEls.choose.addEventListener('click', function () { cpEls.inputFile.click(); });
        [cpEls.inputCam, cpEls.inputFile].forEach(function (input) {
            input.addEventListener('change', function () {
                cpHandleFile(input.files && input.files[0]);
                input.value = '';
            });
        });

        // Desktop drag & drop onto the intro
        ['dragover', 'dragenter'].forEach(function (type) {
            cpEls.intro.addEventListener(type, function (e) {
                e.preventDefault();
                cpEls.intro.classList.add('cpe-dragover');
            });
        });
        ['dragleave', 'drop'].forEach(function (type) {
            cpEls.intro.addEventListener(type, function (e) {
                e.preventDefault();
                cpEls.intro.classList.remove('cpe-dragover');
                if (type === 'drop' && e.dataTransfer && e.dataTransfer.files.length) {
                    cpHandleFile(e.dataTransfer.files[0]);
                }
            });
        });

        // Zoom slider + buttons
        cpEls.zoom.addEventListener('input', function () {
            cpSetZoomT(Number(cpEls.zoom.value) / 100);
        });
        cpEls.zoomIn.addEventListener('click', function () {
            cpSetZoomT(Number(cpEls.zoom.value) / 100 + 0.09);
        });
        cpEls.zoomOut.addEventListener('click', function () {
            cpSetZoomT(Number(cpEls.zoom.value) / 100 - 0.09);
        });

        cpEls.rotate.addEventListener('click', cpRotate90);
        cpEls.retake.addEventListener('click', function () {
            cpEls.intro.hidden = false;
            cpEls.cropWrap.hidden = true;
            cpEls.error.hidden = true;
        });
        cpEls.apply.addEventListener('click', cpApplyPhoto);
        cpEls.close.addEventListener('click', cpCloseEditor);
        cpEls.reopen.addEventListener('click', cpOpenEditor);
        if (cpEls.stepOpen) cpEls.stepOpen.addEventListener('click', cpOpenEditor);
        cpEls.dpiBack.addEventListener('click', function () { cpDpiAnswer(false); });
        cpEls.dpiAnyway.addEventListener('click', function () { cpDpiAnswer(true); });

        window.addEventListener('resize', function () {
            if (cpEditorIsOpen() && cp.source && !cpEls.cropWrap.hidden) {
                cpLayoutStage();
                if (cp.cropRect) cpRestoreViewFromCrop();
                cpAfterViewChange();
            }
        });

        // Deterministic hooks for automated testing
        window.__customPrint = {
            openEditor: cpOpenEditor,
            state: function () {
                return {
                    open: cpEditorIsOpen(),
                    hasPhoto: !!cp.source,
                    applied: cp.applied,
                    ratio: cp.ratioKey,
                    srcW: cp.srcW, srcH: cp.srcH,
                    cropRect: cp.cropRect,
                    view: { s: cp.view.s, offX: cp.view.offX, offY: cp.view.offY, sMin: cp.view.sMin },
                    frameBox: cp.frameBox,
                    previewUrl: cp.previewUrl
                };
            },
            setRatio: cpSetRatio,
            setView: function (s, offX, offY) {
                cp.view.s = s; cp.view.offX = offX; cp.view.offY = offY;
                cpAfterViewChange();
            },
            rotate90: cpRotate90,
            apply: cpApplyPhoto,
            handleFile: cpHandleFile,
            generatePrintFile: function () { return cpGeneratePrintFile(selectedInches()); }
        };

        // Auto-open on arrival
        cpOpenEditor();
    }

    // ── Test hooks + init ────────────────────────────────────────────────
    window.__pdp = {
        state: function () {
            return {
                idx: activeConfigIdx,
                orientation: artworkOrientation,
                selection: productSelections[activeConfigIdx],
                view: currentView,
                room: activeRoomIdx
            };
        },
        setFinish: function (key) {
            var idx = finishToIdx[key];
            if (idx == null) return;
            activeConfigIdx = idx;
            renderAll();
            applySelectionTo3D();
        },
        setSize: function (label) {
            var def = productConfigDefs[activeConfigIdx] || {};
            var sel = productSelections[activeConfigIdx] || {};
            var sizes = sizesFor(def) || [];
            var match = sizes.filter(function (s) { return normalizeOption(s.label) === normalizeOption(label); })[0];
            if (!match) return;
            sel.shape = match.shape || 'rect';
            sel.size = match;
            renderAll();
            applySelectionTo3D();
        },
        setView: setView,
        resolveVariant: function () { return resolveVariant(activeConfigIdx, productSelections[activeConfigIdx]); }
    };

    if (!sizesFor(productConfigDefs[activeConfigIdx])) activeConfigIdx = firstAvailableIdx();
    if (!window.CUSTOM_PRINT_MODE) { chooseCheapestConfiguration(); restoreConfigurationFromUrl(); }
    renderRoomChips();
    syncViewUI();
    renderAll();
    if (!CUSTOMIZER_DATA.artwork || !CUSTOMIZER_DATA.artwork.orientation) detectArtworkOrientation();

    // Homepage deep links: ?wall=1 opens the camera visualiser, ?room=1 the
    // staged-room view (used by the hero/visualiser CTAs on the home page).
    (function () {
        var params = new URLSearchParams(window.location.search);
        if (params.get('wall') === '1') {
            if (window.PDP_BOOT) window.PDP_BOOT.request();
            setTimeout(function () {
                if (window.__wallViz) window.__wallViz.open();
            }, 650);
        } else if (params.get('room') === '1') {
            setTimeout(function () { setView('room'); }, 400);
        }
    })();
})();
